import { createReducer } from 'redux-act';
import * as actions from './actions';
import { LESSON_TYPES } from 'utils/constants';

const initialState = {
  type: LESSON_TYPES.DEFAULT,
  isConcurrentBooking: true,
};

const bookingReducer = createReducer(
  {
    [actions.updateBookingState]: (state, payload) => ({ ...state, ...payload }),
    [actions.clearBookingState]: () => ({ ...initialState }),
  },
  initialState
);

export default bookingReducer;
